import { CSSProperties } from "react";
import { IButtonProps } from "./Button.interface";

function Button(props: IButtonProps) {
    const {
        type,
        label,
        children,
        onClick,
        variant,
        state = "normal",
        icon,
        iconSize,
        isIconRight,
        customCss = "",
        disabled
    } = props;
    const getVariant = () => {
        switch (`${variant}-${state}`) {
            case "solid-normal":
                return {
                    css: "is_solid text-bd2-bd",
                    mainColor: "green-500",
                    textColor: "neutrals-darker"
                };
            case "outlined-normal":
                return {
                    css: "is_outlined text-bd2-bd",
                    mainColor: "green-700",
                    textColor: "neutrals-darker"
                };
            case "link-normal":
                return {
                    css: "is_link text-bd2-bd",
                    mainColor: "green-500",
                    textColor: "CurrentColor"
                };

            default:
                return {
                    css: "",
                    mainColor: "",
                    textColor: ""
                };
        }
    };

    return (
        <button
            type={type}
            disabled={disabled}
            style={
                {
                    "--main-color": `var(--${getVariant().mainColor})`,
                    "--text-color": `var(--${getVariant().textColor})`
                } as CSSProperties
            }
            className={`button ${customCss} ${getVariant().css} ${isIconRight ? "flex-row-reverse" : ""}`}
            onClick={onClick}>
            {icon && <i className={`icon icon-${iconSize ?? 24} icon-${icon}`}></i>}
            {label && <span>{label}</span>}
            {children && <>{children}</>}
        </button>
    );
}

export default Button;
